export const GET_SCHEDA_PERSONA_ESISTENTE_VIEWLET = 'GET_SCHEDA_PERSONA_ESISTENTE_VIEWLET';

/**
 * Get persona telefoni.
 * @function getPersonaTelefoni
 * @param {Object} data Data.
 * @returns {Object} Get querystringsearch results action.
 */
export function getSchedaPersonaEsistenteViewlet(user_id) {
    return {
        type: GET_SCHEDA_PERSONA_ESISTENTE_VIEWLET,
        request: {
            op: 'post',
            path: `/@getSchedaPersonaEsistenteViewlet`,
        },
        user_id: user_id,
    };
}
